import React, { useEffect, useState } from "react";
import { fetchSessionsDatabase, fetchAteliersDatabase } from "../../services/nocodb";

import ListItem from "./ListItem";
import AtelierGrid from "./AtelierGrid";

const CACHE_EXPIRY_MS = 1000 * 60 * 60; // 1 hour
const SESSIONS_CACHE_KEY = "cachedSessions";
const ATELIERS_CACHE_KEY = "cachedAteliers";

function List() {
  const [sessions, setSessions] = useState([]);
  const [ateliers, setAteliers] = useState([]);
  const [selectedSession, setSelectedSession] = useState(null);
  const [filteredAteliers, setFilteredAteliers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadData() {
      const now = Date.now();

      const sessionsCached = localStorage.getItem(SESSIONS_CACHE_KEY);
      const sessionsTimestamp = localStorage.getItem(`${SESSIONS_CACHE_KEY}_timestamp`);
      const sessionsCacheValid = sessionsCached && sessionsTimestamp && now - sessionsTimestamp < CACHE_EXPIRY_MS;

      const ateliersCached = localStorage.getItem(ATELIERS_CACHE_KEY);
      const ateliersTimestamp = localStorage.getItem(`${ATELIERS_CACHE_KEY}_timestamp`);
      const ateliersCacheValid = ateliersCached && ateliersTimestamp && now - ateliersTimestamp < CACHE_EXPIRY_MS;

      try {
        let sessionsData, ateliersData;

        if (sessionsCacheValid) {
          sessionsData = JSON.parse(sessionsCached);
        } else {
          sessionsData = await fetchSessionsDatabase();
          localStorage.setItem(SESSIONS_CACHE_KEY, JSON.stringify(sessionsData));
          localStorage.setItem(`${SESSIONS_CACHE_KEY}_timestamp`, now.toString());
        }

        if (ateliersCacheValid) {
          ateliersData = JSON.parse(ateliersCached);
        } else {
          ateliersData = await fetchAteliersDatabase();
          localStorage.setItem(ATELIERS_CACHE_KEY, JSON.stringify(ateliersData));
          localStorage.setItem(`${ATELIERS_CACHE_KEY}_timestamp`, now.toString());
        }

        setSessions(sessionsData);
        setAteliers(ateliersData);
      } catch (err) {
        console.error("Error loading data from NocoDB", err);
      } finally {
        setLoading(false);
      }
    }

    loadData();
  }, []);

  useEffect(() => {
    if (!selectedSession) return;

    const atelierIds = selectedSession._nc_m2m_sessions_2_ateliers_1s.map(m2m => m2m.ateliers_1_id);
    const filtered = ateliers.filter(a => atelierIds.includes(a.Id));
    setFilteredAteliers(filtered);
  }, [selectedSession, ateliers]);

  if (loading) return <div className={"loader"}></div>;

  return (
    <div>
      <div className="row mb-4">
        {sessions.map((session) => (
          <div className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4 d-flex justify-content-center" key={session.Id}>
            <ListItem
              session={session}
              onClick={() => setSelectedSession(session)}
              isSelected={selectedSession?.Id === session.Id}
            />
          </div>
        ))}
      </div>

      <div className="row">
        <AtelierGrid ateliers={filteredAteliers} selectedSession={selectedSession} />
      </div>
    </div>
  );
}

export default List;